export default {"src":"/blog/_next/static/media/post_author_large.06eeb3b6.svg","height":144,"width":144};